import { useState, useCallback, useEffect } from 'react';
import { getHeroOpinionSummary } from '@op/services/hero';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { useStableValue } from '@opm/utils/stableKey';
/**
 * Hero 舆情总结 Hook
 * 使用 /hero/opinion_summary (view_mode=summary) 获取 GPT 摘要报告
 */
export const useHeroOpinionSummary = (filter: any) => {
  const [reportCn, setReportCn] = useState('');
  const [reportEn, setReportEn] = useState('');
  const filterParams = useStableValue(filter);

  const { loading, wrapperCancelRequest } = useCancelRequestHook();
  const fetchReport = useCallback((params: any) => {
    return wrapperCancelRequest(getHeroOpinionSummary, params).then(
      (data: any) => {
        const responseData = data?.data || data || {};
        setReportCn(responseData.opinion_summary_cn || '');
        setReportEn(responseData.opinion_summary_en || '');
        return responseData;
      },
    );
  }, []);

  useEffect(() => {
    if (!filterParams) return;
    fetchReport(filterParams);
  }, [filterParams]);

  return {
    reportCn,
    reportEn,
    loading,
    fetchReport,
  };
};
